/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UtmSave200ResponseData } from './UtmSave200ResponseData'
import {
  UtmSave200ResponseDataFromJSON,
  UtmSave200ResponseDataFromJSONTyped,
  UtmSave200ResponseDataToJSON,
} from './UtmSave200ResponseData'

/**
 *
 * @export
 * @interface UtmSave200Response
 */
export interface UtmSave200Response {
  /**
   *
   * @type {boolean}
   * @memberof UtmSave200Response
   */
  status: boolean
  /**
   *
   * @type {UtmSave200ResponseData}
   * @memberof UtmSave200Response
   */
  data: UtmSave200ResponseData
}

/**
 * Check if a given object implements the UtmSave200Response interface.
 */
export function instanceOfUtmSave200Response(
  value: object
): value is UtmSave200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function UtmSave200ResponseFromJSON(json: any): UtmSave200Response {
  return UtmSave200ResponseFromJSONTyped(json, false)
}

export function UtmSave200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UtmSave200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: UtmSave200ResponseDataFromJSON(json['data']),
  }
}

export function UtmSave200ResponseToJSON(
  value?: UtmSave200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: UtmSave200ResponseDataToJSON(value['data']),
  }
}
